
import { useQuery as useConvexQuery } from "convex/react";
import { api } from "../../api";
import { toConvexId } from "@/types/convex";

export const useDeviceLevelData = (deviceId: string) => {
  // Get device details from Convex
  const deviceDetails = useConvexQuery(
    api.devices.get.details,
    deviceId ? { device: toConvexId.device(deviceId) } : "skip"
  );

  return {
    level: deviceDetails?.level,
    user: deviceDetails?.user,
    device: deviceDetails?.device,
    isLoading: deviceDetails === undefined,
    error: null,
  };
};
